<template>
  <div>
    <div class="doctorPage doctorSeach">
      <div class="selectSearch" style="padding-right: 78px;">
        <el-form
          ref="form"
          :model="appealParameter"
          class="qcFrom"
          :inline="true"
        >
          <el-form-item label="中心列表">
            <el-select
              v-model="appealParameter.hospCode"
              filterable
              placeholder="请选择中心"
              size="mini"
              class="name"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="(item, itemIndex) in allHospitalsData.Hospitals"
                :key="itemIndex"
                :label="item.HospitalName"
                :value="item.HospitalGuid"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dateForm" label="选择时间">
            <el-date-picker
              class="time"
              v-model="appealParameter.qcTime"
              type="month"
              size="mini"
              placeholder="选择时间"
              prefix-icon="el-icon-caret-bottom"
              format="yyyy-MM"
              value-format="yyyy-MM"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="质控记录人">
            <el-input
              v-model="appealParameter.createdName"
              class="name"
              placeholder="请输入质控记录人"
              size="mini"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="状态">
            <el-select v-model="appealParameter.appealStatus" placeholder="请选择状态" size="mini" class="name">
              <el-option label="质控中" value="0"></el-option>
              <el-option label="质控完成" value="1"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="search" round>查询</el-button>
            <el-button
              type="primary"
              class="resetBtn"
              @click="resetForm('form')"
              >重置</el-button
            >
          </el-form-item>
          <el-form-item
            v-if="hosList.length > 0"
            label="浏览模式"
            style="position: absolute;right: 25px;top: 15px;"
          >
            <el-switch
              v-model="browse"
              active-color="#3178FC"
              inactive-color="#3D4049"
              @change="changeBrowse()"
            ></el-switch>
          </el-form-item>
        </el-form>
      </div>
      <div class="centerHome">
        <div class="ccHomel">
          <div class="compentTable" v-if="!browse">
            <el-table class="qcTable" :data="hosList" v-loading="loading">
              <el-table-column
                type="index"
                label="序号"
                width="80"
              ></el-table-column>
              <el-table-column
                prop="HospName"
                label="中心名称"
                min-width="100"
              ></el-table-column>
              <el-table-column prop="QcDate" label="质控日期" sortable>
                <template slot-scope="scope">
                  {{ scope.row.QcDate.substring(0, 10) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="CreatedName"
                label="质控记录人"
              ></el-table-column>
              <!-- <el-table-column prop="CheckingItems" label="状态"></el-table-column> -->
              <el-table-column
                prop="QcMembers"
                label="质控成员"
              ></el-table-column>
              <el-table-column prop="" label="操作" width="180">
                <template slot-scope="scope">
                  <span
                    class="tableOpe marr15"
                    @click="experClick(scope.row, scope.$index)"
                    >详情</span
                  >
                  <span
                    class="tableOpe marr15"
                    v-if="!scope.row.FinalReview"
                    @click="edit(scope.row, scope.$index)"
                    >编辑</span
                  >
                  <span
                    class="tableOpe textColorRed"
                    v-if="scope.row.State == 10"
                    @click="exportReport(scope.row)"
                    >导出</span
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="pages">
              <el-pagination
                class="pageAll"
                layout="prev, pager, next"
                :total="total"
                :page-size="appealParameter.pageSize"
                :current-page="appealParameter.pageIndex"
                @current-change="currentChange"
              ></el-pagination>
            </div>
          </div>
          <div class="preview" v-else>
            <el-row :gutter="10">
              <el-col :span="8">
                <div class="compentTable recordLeft">
                  <div class="title">
                    <span>质控记录列表</span>
                    <span>共 {{ hosList.length }} 条</span>
                  </div>
                  <ul
                    class="list"
                    :style="{
                      height: height + 'px',
                      overflow: 'auto',
                      padding: '0 20px',
                    }"
                  >
                    <li
                      v-for="(item, index) in hosList"
                      :key="index"
                      :class="item.active ? 'liActive' : ''"
                      @click="listDetail(item, index)"
                    >
                      <div class="name">{{ item.HospName }}</div>
                      <div class="gray">{{ item.CreatedName }}</div>
                      <div class="bottom">
                        <span class="gray">{{
                          item.QcDate.substring(0, 10)
                        }}</span>
                        <span v-if="item.State == 1" class="yellow">
                          <svg-icon
                            class="fz14 marr5"
                            icon-class="but_examine"
                          ></svg-icon>
                          审核中...
                        </span>
                        <span class="green" v-if="item.State == 10">
                          <svg-icon
                            class="fz14 marr5"
                            icon-class="icon_complete"
                          ></svg-icon>
                          质控完成
                        </span>
                      </div>
                    </li>
                  </ul>
                </div>
              </el-col>
              <el-col :span="16">
                <div
                  class="compentTable"
                  :style="{ height: height + 30 + 'px', overflow: 'auto' }"
                >
                  <div>
                    <div style="text-align:center;margin-bottom:20px">
                      {{ detailContent.QcInfo.HospName }}
                    </div>
                    <!-- <el-button class="export-btn" type="primary" size="mini">
                      导出报告
                    </el-button> -->
                    <div>
                      <div
                        class="textr pdfBtn"
                        v-if="
                          detailContent.QcInfo.FinalReview &&
                            detailContent.QcInfo.State == 10
                        "
                      >
                        <el-button
                          @click="exportReport(detailContent.QcInfo)"
                          type="primary"
                          class="export-btn"
                        >
                          导出pdf报告
                        </el-button>
                      </div>
                      <div
                        v-if="
                          type != 'edit' && !detailContent.QcInfo.FinalReview
                        "
                        class="textr"
                      >
                        <el-button
                          class="pelorousbg"
                          v-if="detailContent.QcInfo.State == 1"
                          @click="examine"
                          type="primary"
                        >
                          审核
                        </el-button>
                        <el-button
                          @click="edit(detailContent.QcInfo)"
                          type="primary"
                        >
                          编辑
                        </el-button>
                        <el-button
                          v-if="
                            detailContent.QcInfo.State == 10 &&
                              !detailContent.QcInfo.FinalReview
                          "
                          class="export-btn"
                          type="primary"
                          size="mini"
                          @click="exportReport(detailContent.QcInfo)"
                        >
                          导出报告
                        </el-button>
                        <el-upload
                          class="marb18"
                          style="display: inline-block;margin-left: 10px;"
                          :action="pdffileUpload"
                          :headers="{
                            'Content-Type': 'application/octet-stream',
                          }"
                          accept=".pdf"
                          :before-upload="pdfbeforeAvatarUpload"
                          :show-file-list="false"
                          :limit="10"
                          :auto-upload="false"
                          :on-change="pdfgetFile"
                          :on-error="pdfhandleError"
                          v-if="detailContent.QcInfo.State == 10"
                        >
                          <el-button
                            class="export-btn"
                            type="danger"
                            size="mini"
                          >
                            上传pdf报告
                          </el-button>
                        </el-upload>
                      </div>
                      <div v-if="type == 'edit'" class="textr">
                        <el-button
                          class="marr10 frame"
                          @click="cancellation"
                          type="primary"
                        >
                          取消
                        </el-button>
                        <el-button type="primary" @click="save">
                          保存
                        </el-button>
                      </div>
                    </div>
                  </div>
                  <div style="margin-bottom:20px">
                    <!-- <div class="name">{{ detailContent.QcInfo.HospName }}</div> -->
                    <div class="fz12">
                      <span
                        class="green marr20"
                        v-if="detailContent.QcInfo.State == 10"
                      >
                        <svg-icon
                          class="fz14 marr5"
                          icon-class="icon_complete"
                        ></svg-icon>
                        质控完成
                      </span>
                      <span
                        class="yellow marr20"
                        v-if="detailContent.QcInfo.State == 1"
                      >
                        <svg-icon
                          class="fz14 marr5"
                          icon-class="but_examine"
                        ></svg-icon>
                        审核中...
                      </span>
                      <span class="gray marr20">{{
                        detailContent.QcInfo.QcDate.substring(0, 10)
                      }}</span>
                      <span class="gray marr20">{{
                        detailContent.QcInfo.QcMembers
                      }}</span>
                    </div>
                  </div>
                  <div id="collspse">
                    <el-form
                      ref="formcollinfo"
                      :model="detailContent"
                      class="qcFrom collspseFrom"
                      :inline="true"
                    >
                      <el-collapse v-model="activeName" accordion>
                        <el-collapse-item name="1">
                          <template slot="title">
                            <svg-icon
                              class="fz14 marr5"
                              icon-class="lab_1"
                            ></svg-icon>
                            <span>现场质控信息</span>
                          </template>
                          <div style="display: flex;">
                            <el-row>
                              <el-col :span="12">
                                <el-form-item label="中心名称" prop="HospCode">
                                  <el-select
                                    v-model="detailContent.QcInfo.HospCode"
                                    placeholder="所有中心"
                                    @change="selectChange"
                                    disabled
                                  >
                                    <el-option
                                      v-for="(item,
                                      index) in allHospitalsData.Hospitals"
                                      :key="index"
                                      :label="item.HospitalName"
                                      :value="item.HospitalGuid"
                                    ></el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                              <el-col :span="12">
                                <el-form-item label="质控时间" prop="QcDate">
                                  <el-date-picker
                                    v-model="detailContent.QcInfo.QcDate"
                                    type="date"
                                    placeholder="选择日期时间"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    :disabled="type !== 'edit'"
                                  ></el-date-picker>
                                </el-form-item>
                              </el-col>
                              <el-col :span="12">
                                <el-form-item
                                  label="质控组成员"
                                  prop="QcMembers"
                                >
                                  <el-input
                                    v-model="detailContent.QcInfo.QcMembers"
                                    class="name"
                                    placeholder="请输入质控组成员"
                                    size="mini"
                                    :disabled="type !== 'edit'"
                                  ></el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </div>
                        </el-collapse-item>
                        <el-collapse-item
                          v-for="(item, index) in detailContent.QcInfoScore"
                          :key="index"
                          :name="index + 1"
                        >
                          <template slot="title">
                            <svg-icon
                              class="fz14 marr5"
                              icon-class="lab_3"
                            ></svg-icon>
                            <span>{{ item.ScoreName }}</span>
                            <!-- <span class="scorelabel">总分6分</span> -->
                          </template>
                          <div
                            v-for="(items,
                            indexs) in item.QualityControlDetails"
                            :key="indexs"
                            style="margin-top:20px"
                          >
                            <el-row>
                              <el-col :span="12">
                                <el-form-item
                                  :label="
                                    items.ScoreName +
                                      '(标准评分: ' +
                                      items.CriterionPoint +
                                      ')'
                                  "
                                >
                                  <el-select
                                    v-model="items.AvailablePointCheck"
                                    placeholder="请选择扣分"
                                    @change="
                                      scoreCalculation(
                                        item.QualityControlDetails
                                      )
                                    "
                                    :disabled="type !== 'edit'"
                                  >
                                    <el-option
                                      label="不扣分"
                                      :value="0"
                                    ></el-option>
                                    <el-option
                                      v-for="(fraction,
                                      fraIndex) in items.AvailablePoint"
                                      :key="fraIndex"
                                      :label="fraction"
                                      :value="fraction"
                                    ></el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                              <el-col :span="12">
                                <div class="coltextarea">
                                  {{ items.ViewMode + items.MarkingScheme }}
                                </div>
                              </el-col>
                            </el-row>
                            <el-row>
                              <el-col id="sceneremarks">
                                <div
                                  class="tips"
                                  v-if="
                                    items.AvailablePointCheck !== 0 &&
                                      items.Note == undefined
                                  "
                                >
                                  <i
                                    class="iconfont iconjingshi1"
                                    style="color: #FCAE23;"
                                  ></i>
                                  扣分必须填写备注（扣分原因）否则无法提交
                                </div>
                                <el-form-item label="备注">
                                  <el-input
                                    class="sceneremarks"
                                    v-model="items.Note"
                                    type="textarea"
                                    size="mini"
                                    value=""
                                    placeholder="请输入备注"
                                    :disabled="type !== 'edit'"
                                  ></el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>
                            <el-row>
                              <el-col>
                                <el-upload
                                  class="upload-demo marb18"
                                  :action="fileUpload"
                                  :headers="{
                                    'Content-Type': 'application/octet-stream',
                                  }"
                                  accept="image/jpeg,image/png,image/jpg"
                                  :before-upload="beforeAvatarUpload"
                                  :show-file-list="false"
                                  :limit="10"
                                  :auto-upload="false"
                                  :on-change="getFile"
                                  :on-error="handleError"
                                  @click="getappealIndex(index, indexs)"
                                  v-if="type == 'edit'"
                                >
                                  <i
                                    class="el-icon-plus avatar-uploader-icon"
                                    @click="getappealIndex(index, indexs)"
                                  ></i>
                                </el-upload>
                                <ul class="imgList">
                                  <li
                                    v-for="(imgitem, imgindex) in items.Url"
                                    :key="imgindex"
                                    class="marr15"
                                  >
                                    <div
                                      class="deleteImg"
                                      @click="
                                        deleteImg(index, indexs, imgindex)
                                      "
                                      v-if="type == 'edit'"
                                    >
                                      <i class="iconfont el-icon-close"></i>
                                    </div>
                                    <img
                                      class="drawerImg"
                                      @click="
                                        handlePictureCardPreview(imgitem.Path)
                                      "
                                      :src="imgitem.Path"
                                      alt=""
                                    />
                                  </li>
                                </ul>
                              </el-col>
                            </el-row>
                          </div>
                        </el-collapse-item>
                        <el-collapse-item :name="88">
                          <template slot="title">
                            <svg-icon
                              class="fz14 marr5"
                              icon-class="lab_4"
                            ></svg-icon>
                            <span>患者影像报告抽样</span>
                          </template>
                          <div>
                            <!-- <el-button type="primary" class="btnColor" v-if="type == 'edit'" @click="handleClick()">
                              <el-icon>
                                <plus />
                              </el-icon>
                              新增抽样患者
                            </el-button> -->
                            <el-table
                              :data="tableData"
                              class="qcTable scrollbar"
                            >
                              <el-table-column
                                v-for="(column, index) in tableColumns"
                                :key="index"
                                :label="column.label"
                                :prop="column.prop"
                                :width="column.width"
                              ></el-table-column>
                              <el-table-column
                                v-if="tableData.length > 0 && type == 'edit'"
                                align="center"
                                prop=""
                                label="操作"
                                fixed="right"
                              >
                                <template slot-scope="scope">
                                  <el-button
                                    type="primary"
                                    @click="handleClick(scope.$index)"
                                    size="small"
                                  >
                                    查看
                                  </el-button>
                                </template>
                              </el-table-column>
                            </el-table>
                          </div>
                        </el-collapse-item>
                        <el-collapse-item :name="99">
                          <template slot="title">
                            <svg-icon
                              class="fz14 marr5"
                              icon-class="lab_5"
                            ></svg-icon>
                            <span>现场质控分值展示</span>
                          </template>
                          <div class="score">
                            <div>
                              现场质控管理评分:
                              <span>{{ detailContent.QcInfo.QcScores }}</span>
                            </div>
                            <div>
                              现场报告随机抽样平均分:
                              <span>{{
                                detailContent.QcInfo.QcReportScores
                              }}</span>
                            </div>
                            <div>
                              现场影像随机抽样平均分:
                              <span>{{
                                detailContent.QcInfo.QcImagesScores
                              }}</span>
                            </div>
                          </div>
                        </el-collapse-item>
                      </el-collapse>
                    </el-form>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <el-drawer
      title="患者影像报告抽样"
      :visible.sync="dialogVisible"
      direction="rtl"
      custom-class="demo-drawer"
      ref="drawer"
      :append-to-body="true"
      :modal="false"
      :wrapperClosable="false"
      class="appealDrawer"
      size="80%"
      style="width:80%;color:#fff"
      :before-close="handleClose"
    >
      <div>
        <div class="qualityBox">
          <el-form
            ref="form"
            :model="reportListinfo"
            class="qcFrom"
            :inline="true"
          >
            <div id="collspse">
              <el-form
                ref="formcoll"
                :model="collspsemodel"
                class="qcFrom collspseFrom"
                :inline="true"
              >
                <el-collapse v-model="infoactiveName" accordion>
                  <el-collapse-item name="1">
                    <template v-slot:title>
                      <svg-icon class="svgImg" icon-class="lab_1"></svg-icon>
                      <span class="title">患者信息</span>
                    </template>
                    <div style="display: flex">
                      <el-row>
                        <el-col
                          :span="12"
                          v-for="(item,
                          index) in reportListinfo.PadPatientInfoDto"
                          :key="index"
                          style="height:90px"
                        >
                          <el-form-item
                            class="radstart"
                            v-if="
                              item.Name !== '报告得分' &&
                                item.Name !== '影像得分'
                            "
                            :label="item.Name"
                          >
                            <el-input
                              v-if="item.Type != 'date'"
                              v-model="item.Value"
                              class="name"
                              :placeholder="'请输入' + item.Name"
                              size="mini"
                            ></el-input>
                            <el-date-picker
                              v-else
                              type="date"
                              v-model="item.Value"
                              placeholder="选择日期时间"
                              format="yyyy-MM-dd"
                              value-format="yyyy-MM-dd"
                            ></el-date-picker>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item name="2">
                    <template v-slot:title>
                      <svg-icon class="svgImg" icon-class="lab_3"></svg-icon>
                      <span class="title">报告部分</span>
                      <!-- <span class="scorelabel">总分6分</span> -->
                    </template>
                    <div
                      v-for="(item, index) in reportListinfo.PadReportDto"
                      :key="index"
                      style="margin-top:20px"
                    >
                      <el-row>
                        <el-col :span="24">
                          <el-form-item
                            :label="
                              item.ScoreName +
                                '(标准评分: ' +
                                item.CriterionPoint +
                                ')'
                            "
                          >
                            <el-select
                              v-model="item.AvailablePointCheck"
                              placeholder="请选择"
                              @change="reportScore()"
                            >
                              <el-option label="不扣分" :value="0"></el-option>
                              <el-option
                                v-for="(items, indexs) in item.AvailablePoint"
                                :key="indexs"
                                :label="items"
                                :value="items"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <div>{{ item.ViewMode + item.MarkingScheme }}</div>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col id="sceneremarks">
                          <div
                            class="tips"
                            v-if="
                              item.AvailablePointCheck !== 0 &&
                                item.Note == undefined
                            "
                          >
                            <i
                              class="iconfont iconjingshi1"
                              style="color: #FCAE23;"
                            ></i>
                            扣分必须填写备注（扣分原因）否则无法提交
                          </div>
                          <el-form-item label="备注">
                            <el-input
                              class="sceneremarks"
                              type="textarea"
                              v-model="item.Note"
                              size="mini"
                              value=""
                            ></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col>
                          <el-upload
                            class="upload-demo marb18"
                            :action="fileUpload"
                            :headers="{
                              'Content-Type': 'application/octet-stream',
                            }"
                            accept="image/jpeg,image/png,image/jpg"
                            :before-upload="beforeAvatarUpload"
                            :show-file-list="false"
                            :limit="10"
                            :auto-upload="false"
                            :on-change="getReportFile"
                            :on-error="handleError"
                          >
                            <i
                              class="el-icon-plus avatar-uploader-icon"
                              @click="getreportIndex(index, 0)"
                            ></i>
                          </el-upload>
                          <ul class="imgList">
                            <li
                              v-for="(imgitem, imgindex) in item.Url"
                              :key="imgindex"
                              class="marr15"
                            >
                              <div
                                class="deleteImg"
                                @click="reportDeleteImg(index, imgindex)"
                              >
                                <i class="iconfont el-icon-close"></i>
                              </div>
                              <img
                                class="drawerImg"
                                @click="handlePictureCardPreview(imgitem.Path)"
                                :src="imgitem.Path"
                                alt=""
                              />
                            </li>
                          </ul>
                        </el-col>
                      </el-row>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item name="3">
                    <template v-slot:title>
                      <svg-icon class="svgImg" icon-class="lab_4"></svg-icon>
                      <span class="title">影像部分</span>
                    </template>
                    <div
                      v-for="(item, index) in reportListinfo.PadImagesDto"
                      :key="index"
                      style="margin-top:20px"
                    >
                      <el-row>
                        <el-col :span="24">
                          <el-form-item
                            :label="
                              item.ScoreName +
                                '(标准评分: ' +
                                item.CriterionPoint +
                                ')'
                            "
                          >
                            <el-select
                              v-model="item.AvailablePointCheck"
                              placeholder="请选择"
                              @change="imageScore"
                            >
                              <el-option label="不扣分" :value="0"></el-option>
                              <el-option
                                v-for="(items, avaIndex) in item.AvailablePoint"
                                :key="avaIndex"
                                :label="items"
                                :value="items"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <div>{{ item.ViewMode + item.MarkingScheme }}</div>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col id="sceneremarks">
                          <div
                            class="tips"
                            v-if="
                              item.AvailablePointCheck !== 0 &&
                                item.Note == undefined
                            "
                          >
                            <i
                              class="iconfont iconjingshi1"
                              style="color: #FCAE23;"
                            ></i>
                            扣分必须填写备注（扣分原因）否则无法提交
                          </div>
                          <el-form-item label="备注">
                            <el-input
                              class="sceneremarks"
                              type="textarea"
                              v-model="item.Note"
                              size="mini"
                              value=""
                            ></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col>
                          <el-upload
                            class="upload-demo marb18"
                            action="#"
                            accept="image/jpeg,image/png,image/jpg"
                            :before-upload="beforeAvatarUpload"
                            :show-file-list="false"
                            :limit="10"
                            :auto-upload="false"
                            :on-change="getReportFile"
                            :on-error="handleError"
                          >
                            <i
                              class="el-icon-plus avatar-uploader-icon"
                              @click="getreportIndex(index, 1)"
                            ></i>
                          </el-upload>
                          <ul class="imgList">
                            <li
                              v-for="(imgitem, imgindex) in item.Url"
                              :key="imgindex"
                              class="marr15"
                            >
                              <div
                                class="deleteImg"
                                @click="reportDeleteImg(index, imgindex)"
                              >
                                <i class="iconfont el-icon-close"></i>
                              </div>
                              <img
                                class="drawerImg"
                                @click="handlePictureCardPreview(imgitem.Path)"
                                :src="imgitem.Path"
                                alt=""
                              />
                            </li>
                          </ul>
                        </el-col>
                      </el-row>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </el-form>
            </div>
            <div class="textc" v-if="patientType !== '' && type == 'edit'">
              <el-button type="primary" class="marl20" @click="determine"
                >确定</el-button
              >
            </div>
          </el-form>
        </div>
      </div>
    </el-drawer>
    <el-dialog :modal="false" :visible.sync="visible"
      ><img width="100%" :src="dialogImageUrl" alt=""
    /></el-dialog>
  </div>
</template>

<script>
import Api from "@/api/index.js";
import axios from "@/js/api";
// import report from './imagingReport'
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  data() {
    return {
      reportListinfo: {},
      pickerDate: {},
      TaskListArrData: [],
      sceneParamters: {},
      appealParameter: {
        hospCode: "",
        qcMembers: "",
        qcTime: "",
        type: 1,
        pageIndex: 1,
        pageSize: 10,
      },
      browse: false,
      recordList: [],
      activeName: "1",
      collspsemodel: {},
      tableData: [],
      height: 0,
      dialogVisible: false,
      hosList: [],
      loading: false,
      detailContent: {
        QcInfo: {
          HospCode: "",
          QcDate: "",
          QcMembers: "",
        },
      },
      tableData: [],
      tableColumns: [],
      infoactiveName: "1",
      total: 0,
      dialogImageUrl: "",
      visible: false,
      type: "",
      rules: {
        HospCode: [
          {
            required: true,
            message: "请选择中心名称",
            trigger: ["change", "tigger"],
          },
        ],
        QcDate: [
          {
            required: true,
            message: "请选择质控时间",
            trigger: ["change", "tigger"],
          },
        ],
        QcMembers: [
          {
            required: true,
            message: "请输入质控组成员",
            trigger: ["blur", "tigger"],
          },
        ],
      },
      patientType: "",
      btntype: false,
      index: 0,
      indexs: 0,
      fileUpload: Api.api.scene.uploadImage,
      pdffileUpload: Api.api.scene.pdfUpload,
      reportIndex: 0,
      reportType: 0,
      uniqueId: "",
      detailIndex: 0,
      scrollheight: 0,
    };
  },
  // components: {
  //   report
  // },
  computed: {
    // ...Vuex.mapState('doctor', ['DashboradArr'])
    ...Vuex.mapState("breadcrumb", ["allHospitalsData"]),
  },
  activated() {
    // this.getAllHospitals({
    //   enable: -1,
    //   name: "",
    //   pageIndex: 1,
    //   pageCount: 999999,
    // });
    axios.ajaxGet("get", Api.api.scene.controlList).then((res) => {
      if (res.data.StatusCode == 200) {
        this.allHospitalsData.Hospitals = res.data.Data.ScoreHospital;
      }
    });
    var viewportHeight = window.innerHeight;
    this.height = viewportHeight - 340;
    this.getList();
  },
  beforeRouteLeave(to, from, next) {
    this.dialogVisible = false;
    this.visible = false;
    next();
  },
  methods: {
    // ...Vuex.mapActions("breadcrumb", ["getAllHospitals"]),
    exportReport(row) {
      let text = row.FinalReview ? "PDF" : "文档";
      this.$confirm(`质控报告将以${text}形式导出到本地。`, "导出", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          window.open(
            axios.exportExcel(Api.api.scene.qcexport) + "/" + row.UniqueId
          );
        })
        .catch((err) => {
          this.$message({
            type: "info",
            message: "已取消导出",
          });
        });
    },
    //审核
    examine() {
      let _this = this;
      this.$confirm(
        "是否审核通过当前现场质控记录，通过后仅配置的可编辑人员可对当前记录进行编辑。",
        "审核",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }
      )
        .then(() => {
          axios
            .ajaxPut("put", Api.api.scene.approve, _this.uniqueId)
            .then((res) => {
              if (res.data.StatusCode == 200) {
                _this.getList(1);
                _this.scrollTop(
                  document.getElementsByClassName("list")[0].scrollTop
                );
                _this.$message.success("审核成功");
              }
            });
        })
        .catch((err) => {
          this.$message({
            type: "info",
            message: "已取消审核",
          });
        });
    },
    scrollTop(top) {
      let _this = this;
      this.$nextTick(() => {
        const numberPattern = /\d+/g;
        if (top) {
          document.getElementsByClassName("list")[0].scrollTop = top;
        } else {
          document.getElementsByClassName("list")[0].scrollTop =
            _this.detailIndex * 133 <
            document
              .getElementsByClassName("list")[0]
              .style.height.match(numberPattern)[0]
              ? 0
              : _this.detailIndex * 133;
        }
      });
    },
    //确定
    determine() {
      let padreportError = this.reportWithError(
        this.reportListinfo.PadReportDto
      );
      let padimageError = this.reportWithError(
        this.reportListinfo.PadImagesDto
      );
      let info = this.reportListinfo;
      let list = this.detailContent.QcInfoPatient;
      if (padreportError) {
        this.infoactiveName = "2";
        this.$message.error(`请输入报告部分中${padreportError.name}的扣分原因`);
        return false;
      } else if (padimageError) {
        this.infoactiveName = "3";
        this.$message.error(`请输入影像部分中${padimageError.name}的扣分原因`);
        return false;
      } else {
        for (let i = 0; i < this.reportListinfo.PadPatientInfoDto.length; i++) {
          const item = this.reportListinfo.PadPatientInfoDto[i];
          if (!item.Value) {
            this.$message.error(item.Name + "不能为空");
            return false;
          }
        }
        if (this.patientType == "add") {
          this.detailContent.QcInfoPatient.push(info);
        } else {
          for (let i = 0; i < list.length; i++) {
            let element = list[i];
            if (
              element.PadPatientInfoDto[0].UniqueId ==
              info.PadPatientInfoDto[0].UniqueId
            ) {
              // element = info;
              this.$set(this.detailContent.QcInfoPatient, i, info);
            }
          }
        }
        this.setTableInfo();
        this.dialogVisible = false;
      }
    },
    reportScore() {
      let num = 0;
      let arr = this.reportListinfo.PadReportDto;
      const targetindex = this.reportListinfo.PadPatientInfoDto.findIndex(
        (v) => v.Name === "报告得分"
      );
      for (let i = 0; i < arr.length; i++) {
        const element = arr[i];
        num += Number(element.AvailablePointCheck);
      }
      let qcScores = 100 - Number(num);
      this.reportListinfo.PadPatientInfoDto[targetindex].Value = 0;
      this.reportListinfo.PadPatientInfoDto[targetindex].Value =
        qcScores <= 0 ? 0 : qcScores;
    },
    imageScore() {
      let num = 0;
      let arr = this.reportListinfo.PadImagesDto;
      const targetindex = this.reportListinfo.PadPatientInfoDto.findIndex(
        (v) => v.Name === "影像得分"
      );
      for (let i = 0; i < arr.length; i++) {
        const element = arr[i];
        num += element.AvailablePointCheck;
      }
      let qcScores = 100 - Number(num);
      this.reportListinfo.PadPatientInfoDto[targetindex].Value = 0;
      this.reportListinfo.PadPatientInfoDto[targetindex].Value =
        qcScores <= 0 ? 0 : qcScores;
    },
    scoreCalculation(scoreList) {
      let num = 0;
      let arr = this.detailContent.QcInfoScore;
      // this.detailContent.QcInfo.QcScores = 0;
      for (let i = 0; i < arr.length; i++) {
        const element = arr[i];
        for (let j = 0; j < element.QualityControlDetails.length; j++) {
          const elements = element.QualityControlDetails[j];
          num += elements.AvailablePointCheck;
        }
      }
      let qcScores = 100 - num;
      this.detailContent.QcInfo.QcScores = qcScores <= 0 ? 0 : qcScores;
    },
    reportWithError(details) {
      let result;
      details.forEach((detail, index) => {
        if (
          detail.AvailablePointCheck !== 0 &&
          (!detail.Note || detail.Note === "")
        ) {
          result = {
            index: index,
            name: detail.ScoreName,
          };
          return true; // 结束当前循环
        }
        return false; // 继续循环
      });
      return result;
    },
    checkFirstQualityControlDetailWithError(details) {
      let result;
      details.forEach((item, index) => {
        item.QualityControlDetails.some((detail, indexs) => {
          if (
            detail.AvailablePointCheck !== 0 &&
            (!detail.Note || detail.Note === "")
          ) {
            result = {
              index: index,
              indexs: indexs,
              name: detail.ScoreName,
            };
            return true; // 结束当前循环
          }
          return false; // 继续循环
        });
      });
      return result;
    },
    //保存
    save() {
      let _this = this;
      const firstError = this.checkFirstQualityControlDetailWithError(
        this.detailContent.QcInfoScore
      );
      if (firstError) {
        _this.activeName = Number(firstError.index + 1);
        this.$message.error(`请输入${firstError.name}的扣分原因`);
      } else if (this.tableData.length < 10) {
        this.$message.error("抽样患者需满足10条 ！！！");
      } else {
        this.$refs.formcollinfo.validate((valid) => {
          if (valid) {
            this.detailContent.QcInfo.IsPc = "true";
            axios
              .ajaxPost("post", Api.api.scene.controlEdit, this.detailContent)
              .then((res) => {
                if (res) {
                  this.type = "";
                  // this.detailinfo(_this.UniqueId);
                  for (let i = 0; i < _this.hosList.length; i++) {
                    let element = _this.hosList[i];
                    if (element.UniqueId == _this.uniqueId) {
                      element.HospName = this.detailContent.QcInfo.HospName;
                      element.QcDate = this.detailContent.QcInfo.QcDate;
                    }
                  }
                  this.$message.success("保存成功");
                }
              });
          } else {
            return false;
          }
        });
      }
    },
    //取消
    cancellation() {
      this.type = "";
      this.detailinfo(this.uniqueId);
    },
    //编辑
    edit(item, index) {
      if (item.UniqueId) {
        this.browse = true;
        this.uniqueId = item.UniqueId;
        this.detailinfo(item.UniqueId);
      }
      this.detailIndex = index;
      this.scrollTop();
      this.type = "edit";
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file;
      this.visible = true;
    },
    handleClick(index) {
      this.dialogVisible = true;
      if (index !== undefined) {
        this.patientType = "edit";
        this.reportListinfo = JSON.parse(
          JSON.stringify(this.detailContent.QcInfoPatient[index])
        );
      } else {
        this.patientType = "add";
        axios.ajaxGet("get", Api.api.scene.reportList).then((res) => {
          let arr = JSON.parse(JSON.stringify(res.data.Data));
          arr.PadReportDto.forEach((item) => {
            item.AvailablePointCheck = 0;
            item.Url = [];
          });
          arr.PadImagesDto.forEach((item) => {
            item.AvailablePointCheck = 0;
            item.Url = [];
          });
          arr.PadPatientInfoDto.forEach((item) => {
            if (item.Name == "报告得分" || item.Name == "影像得分") {
              item.Value = 100;
            } else {
              item.Value = "";
            }
          });
          this.reportListinfo = arr;
        });
      }
    },
    handleClose() {
      console.log("2222");
      // this.reportListinfo = {};
      this.dialogVisible = false;
    },
    getList(type) {
      axios
        .ajaxGet("get", Api.api.scene.recordList, this.appealParameter)
        .then((res) => {
          if (res.data.StatusCode == 200) {
            this.hosList = res.data.Data;
            for (let i = 0; i < this.hosList.length; i++) {
              const element = this.hosList[i];
              element.active = false;
            }
            this.total = res.data.Total;
            if (type !== undefined) {
              this.uniqueId = this.hosList[0].UniqueId;
              this.detailinfo(this.hosList[0].UniqueId);
            }
            this.$forceUpdate();
          }
        });
    },
    detailinfo(id) {
      let _this = this;
      for (let i = 0; i < this.hosList.length; i++) {
        const element = this.hosList[i];
        element.active = false;
        if (element.UniqueId == id) {
          element.active = true;
        }
      }
      axios
        .ajaxGet("get", Api.api.scene.controlDetails, { uniqueId: id })
        .then((res) => {
          if (res.data.StatusCode == 200) {
            _this.activeName = "1";
            _this.detailContent = res.data.Data;
            _this.detailContent.QcInfoPatient.sort((a, b) => {
              const getMrn = (item) =>
                item.PadPatientInfoDto.find((info) => info.Name === "病历号")
                  ?.Value || "";

              return getMrn(b).localeCompare(getMrn(a), undefined, {
                numeric: true,
                sensitivity: "base",
              });
            });
            _this.tableData = _this.detailContent.QcInfoPatient.map((item) => {
              const obj = {};
              item.PadPatientInfoDto.forEach((info) => {
                obj[info.Name] = info.Value || 0;
              });
              return obj;
            });
            // _this.tableData = _this.tableData.sort((a, b) => a["病历号"].localeCompare(b["病历号"]));
            _this.tableColumns = _this.detailContent.QcInfoPatient[0].PadPatientInfoDto.map(
              (info) => ({
                label: info.Name,
                prop: info.Name,
                width: info.Name === "检查日期" ? "120px" : "100px",
              })
            );
          }
        });
    },
    fixedNumber(num, decimals) {
      return (
        Math.round(num * Math.pow(10, decimals)) / Math.pow(10, decimals)
      ).toFixed(decimals);
    },
    setTableInfo() {
      let _this = this;
      let list = this.detailContent.QcInfoPatient;
      _this.$nextTick(() => {
        if (list.length == 0) {
          _this.tableData = [];
          _this.tableColumns = [];
        } else {
          _this.tableData = list.map((item) => {
            const obj = {};
            item.PadPatientInfoDto.forEach((info) => {
              obj[info.Name] = info.Value || 0; // 如果Value不存在则默认为空字符串
            });
            return obj;
          });
          _this.tableColumns = list[0].PadPatientInfoDto.map((info) => ({
            label: info.Name,
            prop: info.Name,
            width: info.Name === "检查日期" ? "120px" : "100px",
          }));
          // 计算报告得分和影像得分的平均值
          let totalReportScore = 0;
          let totalImageScore = 0;

          for (let i = 0; i < _this.tableData.length; i++) {
            totalReportScore += Number(_this.tableData[i]["报告得分"]);
            totalImageScore += Number(_this.tableData[i]["影像得分"]);
          }
          // _this.detailContent.QcInfo.QcReportScores = Number(
          //   (totalReportScore / _this.tableData.length).toFixed(1)
          // );
          // _this.detailContent.QcInfo.QcImagesScores = Number(
          //   (totalImageScore / _this.tableData.length).toFixed(1)
          // );
          console.log(totalImageScore, totalReportScore);
          _this.detailContent.QcInfo.QcReportScores = Number(
            _this.fixedNumber(totalReportScore / _this.tableData.length, 1)
          );
          _this.detailContent.QcInfo.QcImagesScores = Number(
            _this.fixedNumber(totalImageScore / _this.tableData.length, 1)
          );
        }
        _this.$forceUpdate();
      });
    },
    datePicker(event) {
      this.appealParameter.start = event[0];
      this.appealParameter.end = event[1];
    },
    resetForm(formName) {
      this.appealParameter = {
        hospCode: "",
        qcMembers: "",
        qcTime: "",
        type: 1,
        pageIndex: 1,
        pageSize: 10,
        UniqueId: "",
      };
      this.search();
    },
    search() {
      this.browse = false;
      this.appealParameter.pageIndex = 1;
      this.appealParameter.pageSize = 10;
      this.getList();
    },
    experClick(item, index) {
      this.browse = true;
      this.detailIndex = index;
      this.uniqueId = item.UniqueId;
      this.detailinfo(item.UniqueId);
    },
    listDetail(item, index) {
      console.log(index);
      this.detailIndex = index;
      this.uniqueId = item.UniqueId;
      this.detailinfo(item.UniqueId);
    },
    changeBrowse() {
      if (this.browse) {
        this.appealParameter.pageIndex = 1;
        this.appealParameter.pageSize = 50;
        this.getList(1);
      } else {
        this.appealParameter.pageIndex = 1;
        this.appealParameter.pageSize = 10;
        this.getList();
      }
    },
    currentChange(val) {
      this.appealParameter.pageIndex = val;
      this.getList();
    },
    selectChange() {
      let listData = this.allHospitalsData.Hospitals;
      for (let i = 0; i < listData.length; i++) {
        if (listData[i].HospitalGuid == this.detailContent.QcInfo.HospCode) {
          this.detailContent.QcInfo.HospName = listData[i].HospitalName;
        }
      }
    },
    getappealIndex(index, indexs) {
      this.index = index;
      this.indexs = indexs;
      console.log(index, indexs, "mmmmmmmmmm");
    },
    getreportIndex(index, type) {
      this.reportIndex = index;
      this.reportType = type;
    },
    deleteImg(index, indexs, imgindex) {
      this.detailContent.QcInfoScore[index].QualityControlDetails[
        indexs
      ].Url.splice(imgindex, 1);
      this.$forceUpdate();
    },
    reportDeleteImg(index, imgindex) {
      if (this.reportType == 0) {
        this.reportListinfo.PadReportDto[this.reportIndex].Url.splice(
          imgindex,
          1
        );
      } else {
        this.reportListinfo.PadImagesDto[this.reportIndex].Url.splice(
          imgindex,
          1
        );
      }
      this.$forceUpdate();
    },
    getReportFile(file, fileList) {
      let _this = this;
      let index = this.reportIndex;
      const formData = new FormData();
      formData.append("file", file.raw);
      axios
        .uploadPost("post", Api.api.scene.uploadImage, formData, {
          "Content-Type": "multipart/form-data; boundary=" + file.uid,
        })
        .then((res) => {
          if (_this.reportType == 0) {
            _this.reportListinfo.PadReportDto[index].Url.push({
              Path: res.data.Data,
            });
          } else {
            _this.reportListinfo.PadImagesDto[index].Url.push({
              Path: res.data.Data,
            });
          }
          _this.$forceUpdate();
        });
    },
    getFile(file, fileList) {
      let _this = this;
      let index = this.index;
      let indexs = this.indexs;
      const formData = new FormData();
      formData.append("file", file.raw);
      axios
        .uploadPost("post", Api.api.scene.uploadImage, formData, {
          "Content-Type": "multipart/form-data; boundary=" + file.uid,
        })
        .then((res) => {
          _this.detailContent.QcInfoScore[index].QualityControlDetails[
            indexs
          ].Url.push({
            Path: res.data.Data,
          });
          _this.$forceUpdate();
        });
    },
    pdfgetFile(file, fileList) {
      let _this = this;
      const id = this.uniqueId;
      const formData = new FormData();
      formData.append("file", file.raw);
      axios
        .uploadPost(
          "post",
          Api.api.scene.pdfUpload + "/" + this.detailContent.QcInfo.UniqueId,
          formData,
          {
            "Content-Type": "multipart/form-data; boundary=" + file.uid,
          }
        )
        .then((res) => {
          // this.$message.success("上传成功");
          this.detailinfo(id);
        });
    },
    handleUploadRemove(file, fileList) {
      this.proofImage = "";
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 1;
      let fname = file.name.toUpperCase();
      if (fname.match("JPG|PNG|JPEG") == null) {
        this.$message.error("上传图片需要JPG或者PNG格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 1MB!");
      }
      return isLt2M;
    },
    pdfbeforeAvatarUpload(file) {
      console.log(file);
      const isLt2M = file.size / 1024 / 1024 < 1;
      let fname = file.name.toUpperCase();
      console.log(fname);
      if (fname.match("PDF") == null) {
        this.$message.error("上传图片需要pdf格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传pdf大小不能超过 1MB!");
      }
      return isLt2M;
    },
    handleError(err, rawFile) {
      // this.$message.error('图片上传错误');
    },
    pdfhandleError(err, rawFile) {
      // this.$message.error('图片上传错误');
    },
    handleRemove(file) {
      console.log(file);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file;
      this.visible = true;
    },
    handleDownload(file) {
      console.log(file);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";
@import "@/assets/style/mixin.scss";
.pdfBtn {
  display: inline-block;
  float: right;
  margin-left: 20px;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
.frame {
  border: 1px solid #248afd;
  color: #248afd !important;
  background: transparent !important;
}

.qualityBox {
  padding: 10px 20px;
}
.score {
  div {
    // color: #ffffff;
    @include text-color(fzColor);
    font-size: 14px;
    margin-bottom: 20px;
    span {
      margin-left: 20px;
    }
  }
}
.svgImg {
  font-size: 26px;
  margin-right: 5px;
}
.imgList {
  margin-top: 20px;
}
.imgList li {
  float: left;
  width: 80px;
  height: 80px;
  position: relative;
  margin-left: 20px;
}
.drawerImg {
  width: 100%;
  height: 100%;
  border-radius: 6px;
}
.deleteImg i {
  background-color: #248afd;
  border-radius: 100px;
  transform: scale(0.8);
  color: #fff;
}
.deleteImg {
  position: absolute;
  width: 18px;
  height: 18px;
  background: #248afd;
  text-align: center;
  line-height: 18px;
  border-radius: 100px;
  right: -7px;
  top: -7px;
}
.btnColor {
  background: #1153cc;
  margin-bottom: 15px;
}
.upload-demo {
  float: left;
}

::v-deep.qcFrom {
  .el-input__icon {
    width: 100%;
    text-align: right;
  }
  .el-input__prefix {
    right: 10px;
    width: 92%;
  }
}
::v-deep #collspse .el-form-item__label {
  text-align: left !important;
  width: 100%;
}
::v-deep #collspse .el-upload {
  border: 1px dashed #9da9b9 !important;
  padding: 0 !important;
  border-radius: 6px !important;
  width: 80px;
  height: 80px;
  line-height: 80px;
  font-size: 25px;
  margin-top: 20px;
}
.scorelabel {
  display: inline-block;
  width: 70px;
  height: 26px;
  background: #3d4049;
  border-radius: 6px;
  font-size: 14px;
  line-height: 26px;
  text-align: center;
  margin-left: 15px;
}
.coltextarea {
  padding: 10px;
  border-radius: 6px;
  // background: #2f343d;
  @include bg-color(totalColor);
  @include text-color(fzColor);
  border: none;
  // color: #fff;
}
.recordLeft {
  padding: 20px 0;
  .title {
    padding: 0 20px;
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    font-weight: 500;
  }
  .list {
    .liActive {
      background: rgba(36, 138, 253, 0.1);
      border-radius: 6px;
      border: 1px solid #248afd;
    }
    li {
      @include bg-color(htmlBg);
      border-radius: 6px;
      padding: 16px;
      margin-top: 10px;
      .bottom {
        font-size: 12px;
        display: flex;
        justify-content: space-between;
      }
    }
  }
}
.name {
  margin-bottom: 23px;
}
.gray {
  color: #a4a4a4;
  font-size: 12px;
  margin-bottom: 8px;
  font-weight: 400;
}
.green {
  color: #22c68b;
}
.yellow {
  color: #ff990c;
}
</style>
